"use client";

import type { FC, ReactNode } from "react";
import { isArray, isString } from "@huub-web/utils";

import type { TemplateVariableType } from "../../types/TemplateVariableType";
import { useTemplates } from "../../hooks";
import { isConditionalIf } from "../../utils";

type TemplateVariableValueProps = { value?: TemplateVariableType | string };

/**
 * ValueParser component is a component that parses a value and displays it in a formatted way.
 */
export const TemplateVariableValue: FC<TemplateVariableValueProps> = ({
  value,
}) => {
  const { dataFieldValues } = useTemplates();

  const display = ((): ReactNode => {
    if (isString(value) || !value) {
      return value;
    }

    const { field, prefix, conditionalField } = value;

    if (dataFieldValues && field) {
      let fieldName = field;
      let valuePrefix = prefix;

      if (isArray(conditionalField)) {
        conditionalField.forEach(
          ({
            field: conditionalFieldName,
            prefix: conditionalPrefix,
            rules,
          }) => {
            // console.log(
            //   `--> ${fieldName}`,
            //   rules,
            //   isConditionalIf(rules, dataFieldValues),
            // );

            if (isConditionalIf(rules, dataFieldValues)) {
              valuePrefix = conditionalPrefix;
              fieldName = conditionalFieldName;
            }
          },
        );
      }

      // console.log(
      //   "   - returning",
      //   dataFieldValues[fieldName],
      //   value?.defaultValue,
      // );

      return (
        <>
          {valuePrefix && <>{valuePrefix} </>}
          {dataFieldValues[fieldName]?.label ??
            dataFieldValues[fieldName]?.value ??
            value?.defaultValue}
        </>
      );
    }

    return value?.defaultValue;
  })();

  return display;
};
